import { ChangeDetectorRef, EventEmitter, NgZone, TemplateRef } from '@angular/core';
import { MessageService } from '../../../message/message.service';
import { Session } from '../../../../shared/model/session.model';
import { TrackerService } from '../../../../core/tracker/tracker.service';
import { AccountService } from '../../../../core/auth/account.service';
import { MessageSendComponent } from '../../../session/chat-ui/message-send/message-send.component';
import { NgbDropdown, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { JhiLanguageService } from '../../../../ng-jhipster/language';
import { CUSTOMER_CARE_CANNED_RESPONSES, debug } from '../../../../app.constants';
import { UserService } from '../../../../core/user/user.service';
import { OfflineMessageService } from '../../../session/offline-message/offline-message.service';
import { ConversationnService } from '../../../conversationn/conversationn.service';
import moment from "moment";
import { SessionService } from '../../../session/session.service';
import * as i0 from "@angular/core";
import * as i1 from "../../../../ng-jhipster/language";
import * as i2 from "../../../message/message.service";
import * as i3 from "../../../../core/auth/account.service";
import * as i4 from "../../../../core/tracker/tracker.service";
import * as i5 from "@ng-bootstrap/ng-bootstrap";
import * as i6 from "../../../../core/user/user.service";
import * as i7 from "../../../conversationn/conversationn.service";
import * as i8 from "../../../session/session.service";
import * as i9 from "../../../session/offline-message/offline-message.service";
import * as i10 from "@angular/common";
import * as i11 from "../../../../shared/auth/has-any-authority.directive";
import * as i12 from "@ctrl/ngx-emoji-mart";
import * as i13 from "@fortawesome/angular-fontawesome";
import * as i14 from "@angular/forms";
import * as i15 from "../../../../shared/auto-direction-switch/input-auto-direction-switch.directive";
import * as i16 from "../../../../ng-jhipster/language/jhi-translate.directive";
import * as i17 from "@ngx-translate/core";
const _c0 = ["emojiDropdown"];
function SessionMessageSendComponent_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 51);
} }
function SessionMessageSendComponent_div_28_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 52);
    i0.ɵɵelementStart(1, "span", 53);
    i0.ɵɵtext(2, "...");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function SessionMessageSendComponent_small_44_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "small", 54);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", ctx_r7.typingMessage, "\u200B");
} }
function SessionMessageSendComponent_small_45_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "small", 54);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "global.Sending..."));
} }
function SessionMessageSendComponent_small_66_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "small", 54);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", ctx_r11.typingMessage, "\u200B");
} }
function SessionMessageSendComponent_small_67_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "small", 54);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "global.Sending..."));
} }
function SessionMessageSendComponent_ng_template_70_tr_14_Template(rf, ctx) { if (rf & 1) {
    const _r20 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "td", 64);
    i0.ɵɵelementStart(2, "span", 65);
    i0.ɵɵlistener("click", function SessionMessageSendComponent_ng_template_70_tr_14_Template_span_click_2_listener() { const restoredCtx = i0.ɵɵrestoreView(_r20); const r_r18 = restoredCtx.$implicit; const modal_r15 = i0.ɵɵnextContext().$implicit; const ctx_r19 = i0.ɵɵnextContext(); const _r6 = i0.ɵɵreference(33); ctx_r19.selectCannedResponse(r_r18.text, _r6); return modal_r15.close(); });
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "td");
    i0.ɵɵelementStart(5, "span", 66);
    i0.ɵɵlistener("click", function SessionMessageSendComponent_ng_template_70_tr_14_Template_span_click_5_listener() { const restoredCtx = i0.ɵɵrestoreView(_r20); const r_r18 = restoredCtx.$implicit; const modal_r15 = i0.ɵɵnextContext().$implicit; const ctx_r22 = i0.ɵɵnextContext(); const _r6 = i0.ɵɵreference(33); ctx_r22.selectCannedResponse(r_r18.text, _r6); return modal_r15.close(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const r_r18 = ctx.$implicit;
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate("/" + r_r18.tag);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("innerHTML", r_r18.text, i0.ɵɵsanitizeHtml);
} }
function SessionMessageSendComponent_ng_template_70_Template(rf, ctx) { if (rf & 1) {
    const _r25 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 55);
    i0.ɵɵelementStart(1, "fa-icon", 56);
    i0.ɵɵlistener("click", function SessionMessageSendComponent_ng_template_70_Template_fa_icon_click_1_listener() { const restoredCtx = i0.ɵɵrestoreView(_r25); const modal_r15 = restoredCtx.$implicit; return modal_r15.close("close"); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "input", 57, 58);
    i0.ɵɵlistener("keydown.enter", function SessionMessageSendComponent_ng_template_70_Template_input_keydown_enter_2_listener() { i0.ɵɵrestoreView(_r25); const ctx_r26 = i0.ɵɵnextContext(); return ctx_r26.clickFirstCannedResponse(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "table", 59);
    i0.ɵɵelementStart(5, "thead");
    i0.ɵɵelementStart(6, "tr");
    i0.ɵɵelementStart(7, "th", 60);
    i0.ɵɵelementStart(8, "span", 61);
    i0.ɵɵtext(9, "Response Tag");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "th", 60);
    i0.ɵɵelementStart(11, "span", 62);
    i0.ɵɵtext(12, "Response Text");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "tbody");
    i0.ɵɵtemplate(14, SessionMessageSendComponent_ng_template_70_tr_14_Template, 6, 2, "tr", 63);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r14 = i0.ɵɵnextContext();
    i0.ɵɵadvance(14);
    i0.ɵɵproperty("ngForOf", ctx_r14.currentCannedResponseList);
} }
const _c1 = function () { return ["ROLE_CUSTOMER_CARE"]; };
const _c2 = function () { return { border: "none" }; };
const _c3 = function (a0) { return { top: a0 }; };
const _c4 = function (a0) { return { "color": a0 }; };
export class SessionMessageSendComponent extends MessageSendComponent {
    constructor(languageService, messageService, accountService, trackerService, ngZone, changeDetectorRef, modalService, userService, conversationService, sessionService, offlineMessageService) {
        super(messageService, accountService, trackerService, changeDetectorRef, ngZone, modalService, languageService, userService);
        this.languageService = languageService;
        this.messageService = messageService;
        this.accountService = accountService;
        this.trackerService = trackerService;
        this.ngZone = ngZone;
        this.changeDetectorRef = changeDetectorRef;
        this.modalService = modalService;
        this.userService = userService;
        this.conversationService = conversationService;
        this.sessionService = sessionService;
        this.offlineMessageService = offlineMessageService;
        this.scriptsModalClicked = new EventEmitter(); // required by session-chat-coach
        this.focusIn = new EventEmitter();
        this.focusOut = new EventEmitter();
        this.modalOptions = { windowClass: 'modal-window', size: 'lg' };
        this.i18nAllLanguages = {
            en: {
                search: "Search",
                emojilist: "List of emoji",
                notfound: "No emoji found",
                clear: "Clear",
                categories: {
                    search: "Search results",
                    recent: "Frequently used",
                    people: "Smileys & people",
                    nature: "Animals & nature",
                    foods: "Food & drink",
                    activity: "Activity",
                    places: "Travel & places",
                    objects: "Objects",
                    symbols: "Symbols",
                    flags: "Flags",
                    custom: "Custom"
                },
                skintones: {
                    1: "Default skin tone",
                    2: "Light skin tone",
                    3: "Medium-light skin tone",
                    4: "Medium skin tone",
                    5: "Medium-dark skin tone",
                    6: "Dark skin tone"
                }
            },
            nl: {
                search: "Search",
                emojilist: "Lijst met emoji",
                notfound: "Geen emoji gevonden",
                clear: "Klaren",
                categories: {
                    search: "Zoekresultaten",
                    recent: "Vaak gebruikt",
                    people: "Smileys en mensen",
                    nature: "Dieren en natuur",
                    foods: "Eten drinken",
                    activity: "Activiteit",
                    places: "Reizen en plaatsen",
                    objects: "Voorwerpen",
                    symbols: "Symbolen",
                    flags: "Vlaggen",
                    custom: "Op maat"
                },
                skintones: {
                    1: "Standaard huidskleur",
                    2: "Lichte huidskleur",
                    3: "Medium-lichte huidtint",
                    4: "Medium huidtint",
                    5: "Middeldonkere huidskleur",
                    6: "Donkere huidskleur"
                }
            }
        };
        this.langKey = this.languageService.getCurrentLanguage() ? this.languageService.getCurrentLanguage() : "en";
        this.i18n = this.i18nAllLanguages[this.langKey];
        this.currentCannedResponseList = CUSTOMER_CARE_CANNED_RESPONSES[this.langKey] ? CUSTOMER_CARE_CANNED_RESPONSES[this.langKey] : CUSTOMER_CARE_CANNED_RESPONSES["en"];
    }
    sendMessage(el, fileInput) {
        var _a;
        if (((_a = this.session) === null || _a === void 0 ? void 0 : _a.future) && moment(this.session.sessionStartTime.toString()).diff(moment(), 'minutes') <= 0) {
            this.sessionService.getSession(this.session.id).subscribe((res) => {
                this.session = res.body;
                this.prepareMessage(el, fileInput);
            }, (err) => {
                console.log(err);
                this.prepareMessage(el, fileInput);
            });
        }
        else {
            this.prepareMessage(el, fileInput);
        }
        console.log(this.session);
    }
    prepareMessage(el, fileInput) {
        if (this.session != null && (this.session.started)) {
            this.sendSessionMessage(el, fileInput);
        }
        else {
            this.sendNonSessionMessage(el, fileInput);
        }
    }
    sendSessionMessage(el, fileInput) {
        debug('Sending session message.');
        this.typing = false;
        let innerHTML = this.trim(el.innerHTML);
        if (innerHTML.length === 0 && this.fileB64 === undefined) {
            return;
        }
        if (innerHTML.length > this.maxCharacterSize) {
            // TODO translate
            window.alert("Message size cannot be longer than " + this.maxCharacterSize);
        }
        if (this.sending) {
            return;
        }
        else {
            this.sending = true;
        }
        let request = {};
        if (this.selectedFile != null || this.fileB64 !== undefined) {
            request['message'] = '___filename___' + this.fileName + '___' + this.fileType + '___' + this.fileFormat + '___' + this.fileB64;
            request["type"] = this.fileType;
        }
        else {
            request['message'] = innerHTML;
            request["type"] = "text";
        }
        request['file'] = this.selectedFile;
        request['sessionId'] = this.session.id;
        if (this.messageToBeReplied !== null && this.messageToBeReplied !== undefined)
            request['replyId'] = this.messageToBeReplied.id;
        this.sending = true;
        console.log(request);
        this.messageService.sendMessage(request).subscribe(() => {
            this.messageToBeReplied = null;
            el.innerHTML = '';
            this.changeMessageCache(el);
            this.messageLength = 0;
            this.sending = false;
            this.resetInputFieldExpand();
            fileInput.value = '';
            this.selectedFile = null;
            this.fileB64 = undefined;
            this.fileType = 'text';
        }, () => {
            window.alert('A problem has occurred sending the message');
            this.sending = false;
        }, () => {
            this.sending = false;
        });
    }
    sendNonSessionMessage(el, fileInput) {
        debug('Sending non session message.');
        this.typing = false;
        let innerHTML = this.trim(el.innerHTML);
        let innerHTMLLength = innerHTML.length;
        if (innerHTML.startsWith('/') && this.isCustomerCareAccount) {
            let innerHTMLTag = innerHTML.slice(1, innerHTMLLength);
            innerHTML = this.currentCannedResponseList.filter((r) => r.tag === innerHTMLTag)[0].text;
            this.message = innerHTML;
            return;
        }
        if (innerHTMLLength === 0 && this.fileB64 === undefined) {
            return;
        }
        if (innerHTMLLength > this.maxCharacterSize) {
            window.alert("Message size cannot be longer than " + this.maxCharacterSize);
            return;
        }
        if (this.sending) {
            return;
        }
        else {
            this.sending = true;
        }
        let userId = this.session.user.id;
        let coachId = this.session.coachId;
        this.conversationService.getConversationByUserIdAndCoachId(userId, coachId).subscribe(response => {
            let currentConversation = response.body;
            let request = {};
            request['message'] = (this.selectedFile != null || this.fileB64 !== undefined) ? '___filename___' + this.fileName + '___' + this.fileType + '___' + this.fileFormat + '___' + this.fileB64 : innerHTML;
            request["type"] = this.fileType;
            request['receiverId'] = this.isCoachAccount ? userId : coachId;
            request['convId'] = currentConversation.id;
            request['sessionId'] = null;
            if (this.messageToBeReplied !== null && this.messageToBeReplied !== undefined)
                request['replyId'] = this.messageToBeReplied.id;
            console.log(request);
            this.offlineMessageService.sendMessage(request).subscribe(() => {
                this.messageToBeReplied = null;
                el.innerHTML = '';
                this.changeMessageCache(el);
                this.messageLength = 0;
                this.sending = false;
                this.resetInputFieldExpand();
                this.selectedFile = null;
                fileInput.value = '';
                this.fileB64 = undefined;
                this.fileType = 'text';
            }, () => {
                window.alert('A problem has occurred sending the message');
                this.sending = false;
            }, () => {
                this.sending = false;
            });
        });
    }
    typingNotify() {
        let now = Date.now();
        let innerHTML = this.messageSendContainer.nativeElement.innerHTML;
        if (innerHTML !== this.currentMessageValue) {
            console.log('notify');
            if (this.session != null &&
                (this.session.active || this.session.started)) {
                this.messageService.typing(this.session.id).subscribe(() => {
                    this.lastNotification = now;
                    this.currentMessageValue = innerHTML;
                });
            }
        }
        else {
            // console.log('do not notify');
        }
    }
    openScriptsModal() {
        this.scriptsModalClicked.emit({});
    }
    open(content) {
    }
    toggleDropdown(e) { }
    select(emoji, messageBox, dropdown) {
        messageBox.innerHTML = messageBox.innerHTML + emoji.emoji.native;
        dropdown.close();
        messageBox.focus();
    }
    selectCannedResponse(text, messageBox) {
    }
    removeReply() {
        this.messageToBeReplied = null;
    }
    checkOverflow(element) {
        return element.offsetHeight > 65;
    }
    toggleInputFieldExpand() {
        this.isInputFieldExpanded = !this.isInputFieldExpanded;
    }
    resetInputFieldExpand() {
        this.isInputFieldExpanded = false;
        this.messageLines = 1;
    }
}
SessionMessageSendComponent.ɵfac = function SessionMessageSendComponent_Factory(t) { return new (t || SessionMessageSendComponent)(i0.ɵɵdirectiveInject(i1.JhiLanguageService), i0.ɵɵdirectiveInject(i2.MessageService), i0.ɵɵdirectiveInject(i3.AccountService), i0.ɵɵdirectiveInject(i4.TrackerService), i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i5.NgbModal), i0.ɵɵdirectiveInject(i6.UserService), i0.ɵɵdirectiveInject(i7.ConversationnService), i0.ɵɵdirectiveInject(i8.SessionService), i0.ɵɵdirectiveInject(i9.OfflineMessageService)); };
SessionMessageSendComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SessionMessageSendComponent, selectors: [["session-message-send"]], viewQuery: function SessionMessageSendComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.emojiDropdown = _t.first);
    } }, inputs: { session: "session", messageToBeReplied: "messageToBeReplied" }, outputs: { scriptsModalClicked: "scriptsModalClicked", focusIn: "focusIn", focusOut: "focusOut" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 72, vars: 49, consts: [[1, "msb-reply", 3, "ngClass"], ["jhiTranslate", "inukaNgApp.offlineMessage.slashForCannedResponse", "style", "font-style: italic; color: dimgray;", 4, "jhiHasAnyAuthority"], [3, "ngClass"], [1, "d-flex", "justify-content-around", "align-items-end"], [1, "d-none", "d-xl-flex", "align-items-center", "message-send-icon"], [3, "click"], ["type", "file", "accept", "image/*", 1, "d-none", 3, "change"], ["fileInput", ""], [1, "attachment-image"], [0, "xlink", "href", "../../../../../../../../content/images/sprite.svg?v=3#attachment"], ["ngbDropdown", "", 1, "d-none", "d-xl-flex", "align-items-center", "message-send-icon", 3, "openChange"], ["emojiDropdown", "ngbDropdown"], ["ngbDropdownToggle", "", 1, "navbar-toggler"], [1, "smiling-face-empty-image"], [0, "xlink", "href", "../../../../../../../../content/images/sprite.svg?v=3#smiling-face-empty"], ["isNative", "true", "ngbDropdownMenu", "", "emoji", "point_up", "title", "Pick your emoji", 3, "skin", "hideObsolete", "showSingleCategory", "perLine", "emojiClick"], [1, "input-div", "input-area"], [1, "reply-div"], ["messageReplayContainer", ""], [1, "d-flex", "justify-content-between"], [1, "d-flex", "justify-content-start"], [1, "reply-icon-div", 3, "title"], ["icon", "reply", 1, "reply-icon"], [1, "vl"], [1, "reply-text", "row"], [3, "innerHTML"], ["overflow", ""], ["class", "ellipsis-div", 4, "ngIf"], [1, "d-flex", "justify-content-end"], [1, "reply-cross"], ["role", "button", "icon", "times-circle", 3, "click"], ["id", "message-send-input", "ngDefaultControl", "", "inputAutoDirectionSwitch", "", "contenteditable", "true", "aria-label", "send message text box", "data-lpignore", "true", 1, "input-field", 3, "innerHTML", "ngModel", "ngModelChange", "keydown.enter", "keyup", "focusin", "focusout"], ["messageSendContainer", ""], [1, "arrow-head-image-div", 3, "ngStyle"], ["id", "message-send-btn", 1, "d-none", "d-xl-inline", 3, "click", "mousedown"], [1, "arrow-head-image"], [0, "xlink", "href", "../../../../../../../../content/images/sprite.svg?v=3#arrow-head"], [1, "d-xl-none", 3, "click", "mousedown"], ["width", "14", "height", "14"], [0, "xlink", "href", "../../../../../../../../content/images/sprite.svg?v=3#expand-arrow"], [1, "d-flex", "d-xl-none", "px-3", "pb-3", "justify-content-between", "align-items-center"], [1, "d-flex"], ["class", "font-weight-bold", "style", "color: #7CBFAE;", 4, "ngIf"], [1, "font-weight-bold", "float-right", 3, "ngStyle"], ["ngbDropdown", "", "placement", "auto", 1, "d-flex", "align-items-center", "mr-4", 3, "openChange"], ["ngbDropdownMenu", "", "emoji", "point_up", "title", "Pick your emoji", 3, "skin", "hideObsolete", "showSingleCategory", "perLine", "emojiClick"], [1, "d-flex", "align-items-center", "mr-4"], [1, "d-flex", "align-items-center"], [3, "click", "mousedown"], [1, "d-none", "d-xl-block", "indicator-div"], ["cannedResponseModal", ""], ["jhiTranslate", "inukaNgApp.offlineMessage.slashForCannedResponse", 2, "font-style", "italic", "color", "dimgray"], [1, "ellipsis-div"], [1, "ellipsis-text"], [1, "font-weight-bold", 2, "color", "#7CBFAE"], [1, "table-responsive", "commands-dialog"], ["role", "button", "icon", "times", 1, "times", 2, "float", "right", "color", "black", "font-size", "20px", "margin", "5px 10px 5px 5px", 3, "click"], ["type", "text", 1, "form-control", 3, "keydown.enter"], ["cannedResponseInput", ""], [1, "table", "table-striped"], ["scope", "col"], ["jhiTranslate", "inukaNgApp.offlineMessage.responseTag"], ["jhiTranslate", "inukaNgApp.offlineMessage.responseText"], [4, "ngFor", "ngForOf"], ["width", "16%"], ["id", "selectedCannedResponse", "type", "button", 3, "click"], ["type", "button", 3, "innerHTML", "click"]], template: function SessionMessageSendComponent_Template(rf, ctx) { if (rf & 1) {
        const _r27 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, SessionMessageSendComponent_span_1_Template, 1, 0, "span", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelementStart(3, "div", 3);
        i0.ɵɵelementStart(4, "div", 4);
        i0.ɵɵelementStart(5, "a", 5);
        i0.ɵɵlistener("click", function SessionMessageSendComponent_Template_a_click_5_listener() { i0.ɵɵrestoreView(_r27); const _r1 = i0.ɵɵreference(7); return _r1.click(); });
        i0.ɵɵelementStart(6, "input", 6, 7);
        i0.ɵɵlistener("change", function SessionMessageSendComponent_Template_input_change_6_listener($event) { i0.ɵɵrestoreView(_r27); const _r6 = i0.ɵɵreference(33); return ctx.onFileSelected($event, _r6); });
        i0.ɵɵelementEnd();
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelementStart(8, "svg", 8);
        i0.ɵɵelement(9, "use", 9);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelementStart(10, "div", 10, 11);
        i0.ɵɵlistener("openChange", function SessionMessageSendComponent_Template_div_openChange_10_listener($event) { return ctx.toggleDropdown($event); });
        i0.ɵɵelementStart(12, "button", 12);
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelementStart(13, "svg", 13);
        i0.ɵɵelement(14, "use", 14);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelementStart(15, "emoji-mart", 15);
        i0.ɵɵlistener("emojiClick", function SessionMessageSendComponent_Template_emoji_mart_emojiClick_15_listener($event) { i0.ɵɵrestoreView(_r27); const _r6 = i0.ɵɵreference(33); const _r2 = i0.ɵɵreference(11); return ctx.select($event, _r6, _r2); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(16, "div", 16);
        i0.ɵɵelementStart(17, "div", 17, 18);
        i0.ɵɵelementStart(19, "div", 19);
        i0.ɵɵelementStart(20, "div", 20);
        i0.ɵɵelementStart(21, "div", 21);
        i0.ɵɵpipe(22, "translate");
        i0.ɵɵelement(23, "fa-icon", 22);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(24, "div", 23);
        i0.ɵɵelementStart(25, "div", 24);
        i0.ɵɵelement(26, "div", 25, 26);
        i0.ɵɵtemplate(28, SessionMessageSendComponent_div_28_Template, 3, 0, "div", 27);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(29, "div", 28);
        i0.ɵɵelementStart(30, "div", 29);
        i0.ɵɵelementStart(31, "fa-icon", 30);
        i0.ɵɵlistener("click", function SessionMessageSendComponent_Template_fa_icon_click_31_listener() { return ctx.removeReply(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(32, "div", 31, 32);
        i0.ɵɵlistener("ngModelChange", function SessionMessageSendComponent_Template_div_ngModelChange_32_listener($event) { return ctx.message = $event; })("keydown.enter", function SessionMessageSendComponent_Template_div_keydown_enter_32_listener() { i0.ɵɵrestoreView(_r27); const _r6 = i0.ɵɵreference(33); const _r1 = i0.ɵɵreference(7); return ctx.onEnterPressed(_r6, _r1); })("keyup", function SessionMessageSendComponent_Template_div_keyup_32_listener($event) { i0.ɵɵrestoreView(_r27); const _r6 = i0.ɵɵreference(33); return ctx.onInput($event, _r6); })("focusin", function SessionMessageSendComponent_Template_div_focusin_32_listener() { return ctx.focusIn.emit(); })("focusout", function SessionMessageSendComponent_Template_div_focusout_32_listener() { return ctx.focusOut.emit(); });
        i0.ɵɵpipe(34, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(35, "div", 33);
        i0.ɵɵelementStart(36, "a", 34);
        i0.ɵɵlistener("click", function SessionMessageSendComponent_Template_a_click_36_listener() { i0.ɵɵrestoreView(_r27); const _r6 = i0.ɵɵreference(33); const _r1 = i0.ɵɵreference(7); return ctx.sendMessage(_r6, _r1); })("mousedown", function SessionMessageSendComponent_Template_a_mousedown_36_listener($event) { return $event.preventDefault(); });
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelementStart(37, "svg", 35);
        i0.ɵɵelement(38, "use", 36);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelementStart(39, "a", 37);
        i0.ɵɵlistener("click", function SessionMessageSendComponent_Template_a_click_39_listener() { return ctx.toggleInputFieldExpand(); })("mousedown", function SessionMessageSendComponent_Template_a_mousedown_39_listener($event) { return $event.preventDefault(); });
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelementStart(40, "svg", 38);
        i0.ɵɵelement(41, "use", 39);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelementStart(42, "div", 40);
        i0.ɵɵelementStart(43, "div", 41);
        i0.ɵɵtemplate(44, SessionMessageSendComponent_small_44_Template, 2, 1, "small", 42);
        i0.ɵɵtemplate(45, SessionMessageSendComponent_small_45_Template, 3, 3, "small", 42);
        i0.ɵɵelementStart(46, "small", 43);
        i0.ɵɵtext(47);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(48, "div", 41);
        i0.ɵɵelementStart(49, "div", 44, 11);
        i0.ɵɵlistener("openChange", function SessionMessageSendComponent_Template_div_openChange_49_listener($event) { return ctx.toggleDropdown($event); });
        i0.ɵɵelementStart(51, "button", 12);
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelementStart(52, "svg", 13);
        i0.ɵɵelement(53, "use", 14);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelementStart(54, "emoji-mart", 45);
        i0.ɵɵlistener("emojiClick", function SessionMessageSendComponent_Template_emoji_mart_emojiClick_54_listener($event) { i0.ɵɵrestoreView(_r27); const _r6 = i0.ɵɵreference(33); const _r2 = i0.ɵɵreference(11); return ctx.select($event, _r6, _r2); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(55, "div", 46);
        i0.ɵɵelementStart(56, "a", 5);
        i0.ɵɵlistener("click", function SessionMessageSendComponent_Template_a_click_56_listener() { i0.ɵɵrestoreView(_r27); const _r1 = i0.ɵɵreference(7); return _r1.click(); });
        i0.ɵɵelementStart(57, "input", 6, 7);
        i0.ɵɵlistener("change", function SessionMessageSendComponent_Template_input_change_57_listener($event) { i0.ɵɵrestoreView(_r27); const _r6 = i0.ɵɵreference(33); return ctx.onFileSelected($event, _r6); });
        i0.ɵɵelementEnd();
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelementStart(59, "svg", 8);
        i0.ɵɵelement(60, "use", 9);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelementStart(61, "div", 47);
        i0.ɵɵelementStart(62, "a", 48);
        i0.ɵɵlistener("click", function SessionMessageSendComponent_Template_a_click_62_listener() { i0.ɵɵrestoreView(_r27); const _r6 = i0.ɵɵreference(33); const _r1 = i0.ɵɵreference(7); return ctx.sendMessage(_r6, _r1); })("mousedown", function SessionMessageSendComponent_Template_a_mousedown_62_listener($event) { return $event.preventDefault(); });
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelementStart(63, "svg", 35);
        i0.ɵɵelement(64, "use", 36);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelementStart(65, "div", 49);
        i0.ɵɵtemplate(66, SessionMessageSendComponent_small_66_Template, 2, 1, "small", 42);
        i0.ɵɵtemplate(67, SessionMessageSendComponent_small_67_Template, 3, 3, "small", 42);
        i0.ɵɵelementStart(68, "small", 43);
        i0.ɵɵtext(69);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(70, SessionMessageSendComponent_ng_template_70_Template, 15, 1, "ng-template", null, 50, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r3 = i0.ɵɵreference(18);
        const _r4 = i0.ɵɵreference(27);
        i0.ɵɵproperty("ngClass", ctx.isInputFieldExpanded ? "expanded-input-field" : "row px-1 message-send-component");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("jhiHasAnyAuthority", i0.ɵɵpureFunction0(40, _c1));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", ctx.isInputFieldExpanded ? "expanded-input-col" : "col");
        i0.ɵɵadvance(1);
        i0.ɵɵclassProp("expanded-input-field-row", ctx.isInputFieldExpanded);
        i0.ɵɵadvance(12);
        i0.ɵɵstyleMap(i0.ɵɵpureFunction0(41, _c2));
        i0.ɵɵproperty("skin", 6)("hideObsolete", true)("showSingleCategory", true)("perLine", 8);
        i0.ɵɵadvance(2);
        i0.ɵɵclassProp("d-none", !ctx.messageToBeReplied);
        i0.ɵɵadvance(4);
        i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(22, 36, "inukaNgApp.offlineMessage.reply"));
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("innerHTML", ctx.messageToBeReplied == null ? null : ctx.messageToBeReplied.message, i0.ɵɵsanitizeHtml);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.checkOverflow(_r4));
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("innerHTML", ctx.message, i0.ɵɵsanitizeHtml)("ngModel", ctx.message);
        i0.ɵɵattribute("aria-placeholder", i0.ɵɵpipeBind1(34, 38, "sessionChat.placeholder.typeAMessage"));
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(42, _c3, _r3.offsetHeight + 10 + "px"));
        i0.ɵɵadvance(9);
        i0.ɵɵproperty("ngIf", !ctx.sending);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.sending);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(44, _c4, ctx.messageLength > ctx.maxCharacterSize ? "red" : "#7CBFAE"));
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate2("", ctx.messageLength, " / ", ctx.maxCharacterSize, "");
        i0.ɵɵadvance(7);
        i0.ɵɵstyleMap(i0.ɵɵpureFunction0(46, _c2));
        i0.ɵɵproperty("skin", 6)("hideObsolete", true)("showSingleCategory", true)("perLine", 8);
        i0.ɵɵadvance(12);
        i0.ɵɵproperty("ngIf", !ctx.sending);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.sending);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(47, _c4, ctx.messageLength > ctx.maxCharacterSize ? "red" : "#7CBFAE"));
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate2("", ctx.messageLength, " / ", ctx.maxCharacterSize, "");
    } }, directives: [i10.NgClass, i11.HasAnyAuthorityDirective, i5.NgbDropdown, i5.NgbDropdownToggle, i12.PickerComponent, i5.NgbDropdownMenu, i13.FaIconComponent, i10.NgIf, i14.DefaultValueAccessor, i15.InputAutoDirectionSwitchDirective, i14.NgControlStatus, i14.NgModel, i10.NgStyle, i16.JhiTranslateDirective, i10.NgForOf], pipes: [i17.TranslatePipe], styles: [".message-send-component[_ngcontent-%COMP%]{margin-top:20px !important}.message-send-icon[_ngcontent-%COMP%]{height:50px;margin-bottom:6px;margin-right:6px}.message-row-user[_ngcontent-%COMP%]{margin-left:10px !important;margin-right:10px !important;width:110%}.message-row-coach[_ngcontent-%COMP%]{margin-left:10px !important;margin-right:10px !important;width:105%}.navbar-toggler[_ngcontent-%COMP%]{padding:0 !important}.input-field[_ngcontent-%COMP%]{padding:0 45px 0 10px;border:none;color:#0a4a3a;line-height:20px;max-height:100px;overflow-y:auto;margin-top:10px;margin-bottom:0;min-height:30px;font-size:16px}.dropdown-toggle[_ngcontent-%COMP%]::after{display:none !important}.input-div[_ngcontent-%COMP%]{width:100% !important;margin-bottom:8px !important}.input-area[_ngcontent-%COMP%]{color:#0a4a3a;border-color:#cce9e0 !important;border-style:solid;border-width:1px 0 0 0;border-radius:0px !important;position:relative;min-height:35px}.input-area[_ngcontent-%COMP%]:empty:before{content:attr(aria-placeholder)}.input-area[_ngcontent-%COMP%]:focus{outline:none !important}.arrow-head-image-div[_ngcontent-%COMP%]{position:absolute;right:10px}.arrow-head-image[_ngcontent-%COMP%], .attachment-image[_ngcontent-%COMP%], .smiling-face-empty-image[_ngcontent-%COMP%]{height:30px;width:30px}.indicator-div[_ngcontent-%COMP%]{line-height:1.2;margin-top:3px !important}.dropdown-menu[_ngcontent-%COMP%]{padding-top:0 !important;padding-bottom:0 !important}.commands-dialog[_ngcontent-%COMP%]{width:100%;max-height:700px;max-width:100%;overflow:auto}@media screen and (max-width: 620px){.commands-dialog[_ngcontent-%COMP%]{max-height:350px}}.reply-div[_ngcontent-%COMP%]{margin:5px auto !important;font-family:\"Open Sans\",serif}.reply-text[_ngcontent-%COMP%]{font-size:12px !important;text-align:left !important;padding:5px 5px 5px 15px !important;height:auto !important;word-break:break-word !important;max-height:65px !important;overflow:hidden}.ellipsis-div[_ngcontent-%COMP%]{position:relative;width:10px}.ellipsis-text[_ngcontent-%COMP%]{position:absolute;top:36px}.reply-cross[_ngcontent-%COMP%]{margin:0 5px 0 0}.reply-icon-div[_ngcontent-%COMP%]{margin:5px}.reply-icon[_ngcontent-%COMP%]{color:#44a38b;font-size:15px}.vl[_ngcontent-%COMP%]{border-left:1px solid #7cbfae;margin:0 5px 0 5px}[_ngcontent-%COMP%]:focus{outline:0 !important;box-shadow:0 0 0 0 rgba(0,0,0,0) !important}@media(min-width: 576px){.message-row-coach[_ngcontent-%COMP%]{width:110%}}@media(min-width: 768px){.message-row-user[_ngcontent-%COMP%]{margin-left:20px !important;margin-right:20px !important}}@media(min-width: 992px){.message-row-coach[_ngcontent-%COMP%]{width:120%}}@media(min-width: 1200px){.message-row-user[_ngcontent-%COMP%]{margin-left:20px !important;margin-right:20px !important}.input-div[_ngcontent-%COMP%]{width:80% !important}.input-area[_ngcontent-%COMP%], .indicator-div[_ngcontent-%COMP%]{margin-right:15px}.input-area[_ngcontent-%COMP%]{border-width:1px;border-radius:6px !important;min-height:50px}.message-row-coach[_ngcontent-%COMP%]{width:115%}}.expanded-input-field[_ngcontent-%COMP%]{position:fixed;top:0px;left:0;height:100%;width:100%;z-index:2000;background-color:#fff}.expanded-input-field[_ngcontent-%COMP%]   .expanded-input-field-row[_ngcontent-%COMP%]{height:calc(100% - 70px)}.expanded-input-field[_ngcontent-%COMP%]   .expanded-input-col[_ngcontent-%COMP%], .expanded-input-field[_ngcontent-%COMP%]   .input-area[_ngcontent-%COMP%]{height:100%}.expanded-input-field[_ngcontent-%COMP%]   .input-field[_ngcontent-%COMP%]{height:calc(100% - 100px) !important;max-height:100% !important}"] });
